<template>
  <div class="page-footer">
    <b-container>
      <div class="layout-row">
        <div class="image">
          <img src="@/assets/img/logo2.png" />
        </div>
        <div class="main start-main">
          <div class="interval"></div>
          <div class="left">
            <img src="@/assets/img/WechatIMG140.png" />
          </div>
          <div class="docx">
            <div class="img">
              <img src="@/assets/img/wxyxty.png" />
            </div>
            <div>
              <div class="oneRow">学院官方微信号：</div>
              <div class="towRow">扫一扫 关注我们 加入我们</div>
              <div class="towRow">获取最新资讯和最贴心服务</div>
            </div>
          </div>
        </div>
        <div class="main end-main">
          <div class="interval"></div>
          <div class="left">
            <img src="@/assets/img/WechatIMG141.png" />
          </div>
          <div class="docx">
            <div class="img">
              <img src="@/assets/img/gzwm.png" />
            </div>
            <div>
              <div class="oneRow">招生就业处官方微信号：</div>
              <div class="towRow">打开手机微信扫一扫，订单拇指</div>
              <div class="towRow">说说话 获取最新招生，就业咨</div>
              <div class="towRow">询。更方便。更快捷。</div>
            </div>
            <div><a style="color: #fff;" href="https://www.miit.gov.cn/" target="_blank">备案号：桂ICP备17010752号</a></div>
          </div>
        </div>
        <div class="main">
          <div class="docx">
            <div>广西建工建筑安装技工学校</div>
            <div>招生信息：广西柳州市柳东新区职教园区（江东大道68号）</div>
            <div>联系电话：0772-2521859、2051867</div>
            <div>培训信息：广西柳州市北雀路100号广西建工技校培训部</div>
            <div>报名地点：广西柳州市柳北区北雀路100号</div>
            <div>报名咨询电话：0772-2521045、2021048</div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
.page-footer {
  background: $theme-6;
  padding: 15px 0;
  display: flex;
  justify-content: center;
  .layout-row {
    display: flex;
    justify-content: space-between;
    .image {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100px; 
      img {
        width: 100%;
      }
    }
    .main {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 15px 0;
      position: relative;
      .left {
        margin-right: 20px;
        width: 80px;
        img {
          width: 100%;
        }
      }
      .docx {
        font-size: 14px;
        color: white;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .oneRow {
          font-size: 16px;
        }
        .towRow {
          color: $gray-5;
        }
      }
    }
    .start-main {
      .interval {
        left: 5%;
      }
    }
    .end-main {
      .interval {
        right: 5%;
      }
    }
  }
  @media screen and (max-width: 768px) {
    .interval {
      display: none;
      position: absolute;
      height: 50px;
      width: 1px;
      background: $gray-6;
    }
    .layout-row{
      flex-direction: column;
    align-items: center;
    }
  }
}
</style>